module.exports = __webpack_public_path__ + "img/photo4.8c638995.jpg";